@if (showControl()) {
  <!-- TODO: KQ: improve track property -->
  @for (error of errorsForDisplay; track error) {
    <div class="invalid-feedback d-flex">
      @if (error.messageKey) {
        {{ error | messageTranslate }}
      } @else {
        {{ error.messageText }}
      }
    </div>
  }
}
